// Summary numbers for the species / kingdom pages (Client/TaxonomyPage.js).
//
// Input is always the output of api/transformSearchResultsToEnzymes.js — one
// object per enzyme, each carrying its full reaction list — so the whole page
// is derived from the single /basicsearch response and no extra requests are
// needed. Counts are over enzymes that have at least one reaction, which is the
// same population the rest of the site counts (statsPageController's
// enzymeCount filters on `enzyme_id in reaction_enzyme_pair`) and the same set
// the page actually lists.

// { [key]: count } -> [[key, count], ...] ordered by count desc, then key asc,
// so equal counts stay in a stable, readable order instead of insertion order.
function sortedCounts(counts) {
  return Object.entries(counts).sort((a, b) => b[1] - a[1] || String(a[0]).localeCompare(String(b[0])));
}

function summariseTaxonomy(enzymes) {
  const typeCounts = {};
  const classCounts = {};
  const kingdomCounts = {};
  const speciesCounts = {};
  const mechanisms = new Set();
  let reactionCount = 0;

  enzymes.forEach(enzyme => {
    // Kingdom/species are per enzyme, so they count enzymes — not reactions.
    kingdomCounts[enzyme.kingdom] = (kingdomCounts[enzyme.kingdom] || 0) + 1;
    speciesCounts[enzyme.species] = (speciesCounts[enzyme.species] || 0) + 1;
    enzyme.reactions.forEach(reaction => {
      reactionCount += 1;
      typeCounts[reaction.type] = (typeCounts[reaction.type] || 0) + 1;
      classCounts[reaction.class] = (classCounts[reaction.class] || 0) + 1;
      if (reaction.mechanism_marts) {
        mechanisms.add(reaction.mechanism_marts);
      }
    });
  });

  return {
    enzymeCount: enzymes.length,
    reactionCount,
    // One mechanism is often shared by several reaction_enzyme_pairs, hence the
    // Set: this is the number of distinct mechanisms, matching how the download
    // and statistics pages count them.
    mechanismCount: mechanisms.size,
    typeCounts: sortedCounts(typeCounts),
    classCounts: sortedCounts(classCounts),
    kingdomCounts: sortedCounts(kingdomCounts),
    speciesCounts: sortedCounts(speciesCounts),
  };
}

export { summariseTaxonomy, sortedCounts };
